import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import SpecialMenuLayout from "@/components/menu-management/special-menu/special-menu-layout";
import { Card } from "@/components/ui/card";
import { TabsList, Tabs, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@/components/ui/separator";
import DraftTabs from "./tabs/draft-list";
import BanquetTabs from "./tabs/banquet-tabs";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import SpecialMenuSkeleton from "@/components/skeleton/special-menu-skeleton";
import useAuth from "@/hooks/useAuth";
import {
  fetchAllBanquets,
  clearBanquetMessages,
} from "@/redux/slice/menu-manage-slice/special-menu/banquet-slice";
import { fetchAllDays } from "@/redux/slice/utility/day-slice";
import { clearItemVariants } from "@/redux/slice/essential-menu-slice/variants-slice";

function BanquetNight() {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const { getLoading } = useSelector((state) => state.menuManage.banquet);

  useEffect(() => {
    dispatch(fetchAllBanquets(user.restaurant_id));
    dispatch(clearBanquetMessages());
    dispatch(clearItemVariants());
    dispatch(fetchAllDays());
  }, [user.restaurant_id]);

  if (getLoading) return <SpecialMenuSkeleton />;
  return (
    <Layout2 LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}>
      <SpecialMenuLayout>
        <Card className="bg-transparent col-span-1 md:col-span-2">
          <Tabs valueKey="special-menu-banquet" className="bg-transparent w-full relative" defaultValue="day">
            <Separator className="absolute top-8" />
            <TabsList className="w-[220px]">
              <TabsTrigger className="bg-transparent" value="day">
                Banquet Night
              </TabsTrigger>
              <TabsTrigger value="draft">Draft List</TabsTrigger>
            </TabsList>
            <BanquetTabs />
            <DraftTabs />
          </Tabs>
        </Card>
      </SpecialMenuLayout>
    </Layout2>
  );
}

export default BanquetNight;
